export const gamesListLimit = 150;
export const paginationLimits = [15, 50, 100, 250, 500, 1000];
export const gamesListLimits = paginationLimits;
export const depositsListLimit = 150;
export const depositsListLimits = paginationLimits;
export const withdrawalsListLimit = 150;
export const withdrawalsListLimits = paginationLimits;
export const analyticListLimit = 150;
export const analyticListLimits = paginationLimits;
export const operationsListLimit = 20;
export const operationsListLimits = paginationLimits;
export const compensationsListLimit = 20;
export const compensationsListLimits = paginationLimits;
export const confiscationsListLimit = 20;
export const confiscationsListLimits = paginationLimits;
export const selectPlayerListLimit = 20;

export const segmentsListLimit = 50;
export const segmentsListLimits = paginationLimits;
export const collectionsListLimit = 50;
export const tagsListLimit = 50;
export const categoriesListLimit = 50;
export const providersListLimit = 50;
export const playersListLimits = paginationLimits;
export const playerBonusesLimit = 30;
export const playerBonusesLimits = paginationLimits;
export const wagersListLimits = paginationLimits;
export const bonusesListLimits = paginationLimits;
export const notificationsListLimits = paginationLimits;
export const emailsListLimits = paginationLimits;
export const loyaltyListLimits = paginationLimits;
export const bannersListLimits = paginationLimits;
export const cashbacksListLimits = paginationLimits;
export const tournamentsListLimits = paginationLimits;
export const promocodesListLimits = paginationLimits;
export const cmsPagesListLimits = paginationLimits;
export const cmsSeoListLimits = paginationLimits;
export const gameCenterLimits = paginationLimits;
export const mirrorLimits = paginationLimits;
export const countriesLimits = paginationLimits;
export const partnersLimits = paginationLimits;
export const socialNetworksLimits = paginationLimits;
export const applicationsLimits = paginationLimits;
export const mainTextLimits = paginationLimits;
export const brandCoreLimits = paginationLimits;
export const paymentsLimits = paginationLimits;
export const currenciesLimits = paginationLimits;
export const riskKycPresetsLimits = paginationLimits;
export const riskKycRulesLimits = paginationLimits;
export const schedulerLimits = paginationLimits;
